// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const styles: any = {
  flexDirection: { lg: 'row' },
  imageContainerW: { lg: '100%' },
  progressFilledTrack: {
    bg: 'black',
  },
};
